// frontend/src/components/AdminTeamDetail/PlayerLinkModal.js
import React from 'react';

const PlayerLinkModal = ({ linkingData, onConfirm, onCancel }) => {
    if (!linkingData) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4">
            <div className="bg-white rounded-lg w-full max-w-2xl p-6">
                <h3 className="text-xl font-bold mb-4">Link Player</h3>
                <p className="text-gray-600 mb-6">
                    A player named <span className="font-semibold">{linkingData.local.player_name}</span> already exists in your roster.
                    Do you want to link them to the Sportradar profile?
                </p>

                <div className="grid grid-cols-2 gap-8 mb-8">
                    {/* Current */}
                    <div className="border rounded-lg p-4 text-center bg-gray-50">
                        <h4 className="font-semibold text-gray-500 mb-4">Current Roster</h4>
                        <div className="aspect-square bg-gray-200 rounded-lg mb-3 flex items-center justify-center overflow-hidden mx-auto w-32">
                            {linkingData.local.photo_url ? (
                                <img src={linkingData.local.photo_url} alt="Current" className="w-full h-full object-cover" />
                            ) : (
                                <span className="text-gray-400">No Photo</span>
                            )}
                        </div>
                        <p className="font-medium">{linkingData.local.player_name}</p>
                        <button
                            onClick={() => onConfirm(false)}
                            className="mt-4 w-full py-2 bg-white border border-gray-300 rounded shadow-sm hover:bg-gray-50 text-sm font-medium"
                        >
                            Keep Current Photo
                        </button>
                    </div>

                    {/* Sportradar */}
                    <div className="border rounded-lg p-4 text-center bg-blue-50 border-blue-100">
                        <h4 className="font-semibold text-blue-600 mb-4">Sportradar</h4>
                        <div className="aspect-square bg-gray-200 rounded-lg mb-3 flex items-center justify-center overflow-hidden mx-auto w-32 relative">
                            {linkingData.remote.images && linkingData.remote.images.length > 0 ? (
                                <img src={linkingData.remote.images[0].url} alt="Sportradar" className="w-full h-full object-cover" />
                            ) : (
                                <span className="text-gray-400">No Photo</span>
                            )}
                        </div>
                        <p className="font-medium">{linkingData.remote.nameFullLatin || linkingData.remote.nameFullLocal}</p>
                        <button
                            onClick={() => onConfirm(true)}
                            className="mt-4 w-full py-2 bg-blue-600 text-white rounded shadow-sm hover:bg-blue-700 text-sm font-medium"
                            disabled={!linkingData.remote.images || linkingData.remote.images.length === 0}
                        >
                            Use Sportradar Photo
                        </button>
                    </div>
                </div>

                <div className="flex justify-end">
                    <button
                        onClick={onCancel}
                        className="text-gray-500 hover:text-gray-700 font-medium px-4"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PlayerLinkModal;
